import React from 'react';
import MDBox from 'components/MDBox';
import { StateCard } from '../ui/ReportsUi';

export function CompanyReportsTab() {
  return (
    <MDBox>
      <StateCard
        icon="insights"
        title="Şirket raporları"
        subtitle="Ciro, tahsilat, borç, günlük özet ve KPI’lar burada."
      />
    </MDBox>
  );
}
